import React from 'react';
import MultiPortfolioConstructionScreen from './MultiPortfolioConstructionScreen';

/**
 * Portfolio Construction Screen - Consolidated Interface
 * 
 * This component now uses the Multi-Portfolio Construction interface,
 * which adapts based on the number of portfolios selected:
 * - 1 portfolio: Simplified single-portfolio view
 * - 2+ portfolios: Full multi-portfolio allocation view
 */
const PortfolioConstructionScreen: React.FC = () => {
  return <MultiPortfolioConstructionScreen />;
};

export default PortfolioConstructionScreen;
